import {
    Bot,
    Brain,
    Compass,
    Cpu,
    FileText,
    Layers,
    Lightbulb,
    MessageSquare,
    Network,
    Puzzle,
    Sparkles,
    Target,
    Users,
    Workflow,
    Zap,
} from 'lucide-react';

/** Fixed pool — varied but assistant/workflow themed, not guessed from text. */
const BLUEPRINT_ICONS = [
    Bot,
    Sparkles,
    Brain,
    Workflow,
    MessageSquare,
    Users,
    Zap,
    Layers,
    Puzzle,
    Compass,
    Lightbulb,
    Target,
    Network,
    Cpu,
];

function stableHash(str) {
    let hash = 0;
    const s = String(str || '');
    for (let i = 0; i < s.length; i += 1) {
        hash = s.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash);
}

/**
 * One stable icon per blueprint (by assistant_id). Same template → same icon every time.
 */
export function getBlueprintVisual(bp) {
    if (bp?.__isBlank) {
        return {
            kind: 'icon',
            Icon: FileText
        };
    }

    const key = bp.assistant_id || bp.title || 'blueprint';
    const Icon = BLUEPRINT_ICONS[stableHash(key) % BLUEPRINT_ICONS.length];
    return {
        kind: 'icon',
        Icon
    };
}
